const mutations = {
  'SET_BUSINESSES_MONTHLY_STATES' (state, { businessesMonthlyStates }) {
    state.businessesMonthlyStates = businessesMonthlyStates;
  }
}

export default mutations